class FooterController {
  constructor($translate, $uibModal, CONFIG) {
    'ngInject';
    this.$translate = $translate;
    this.languages = CONFIG.languages;
    this.$uibModal = $uibModal;
    this.name = 'footer';
  }

  $onInit() {
    //TODO Use languageService
    let language = this.languages[this.$translate.use()];
    this.cookie_policy_note_href = `http://www.suntransfers.com${ language.key == 'en' ? '/' : '/' + language.key + '/' }terms-and-conditions#cookies_policy`;
    this.terms_and_conditions_note_href = `http://www.suntransfers.com${ language.key == 'en' ? '/' : '/' + language.key + '/' }terms-and-conditions`;

    this.values = {
        link_start: '<a class="c-alert-cookie__link" href="' + this.cookie_policy_note_href + '" target="_blank">',
        link_end: '</a>'
    };
  }

  cookieSettings() {
    let modalInstance = this.$uibModal.open({
      animation: false,
      component: 'stCookieSettings',
      windowClass: 'cookie-modal-window'
    });

    return modalInstance.result;
  }
}

export default FooterController;


// WEBPACK FOOTER //
// ./client/app/common/footer/footer.controller.js